var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":"success"},model:{value:(_vm.$store.state.snackbar.show),callback:function ($$v) {_vm.$set(_vm.$store.state.snackbar, "show", $$v)},expression:"$store.state.snackbar.show"}},[_c('v-icon',[_vm._v("mdi-check")]),_vm._v(" "+_vm._s(_vm.$store.state.snackbar.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }